import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiService } from './base-api.service';
import { DateUtil } from '../utils/date-utils';
import { SelectedDnService } from './selected-dn.service';

export interface ContatoLead {
  idLead: number;
  idStatusTo: number;
  dataRetorno: Date;
  observacoes: string;
  vendedor: string;
}


@Injectable({
  providedIn: 'root'
})
export class LeadContatoService extends BaseApiService {

  constructor(
    http: HttpClient,
    private selectedDnService: SelectedDnService,
    // ...existing code...
  ) {
    super(http);
  }

  atualizarContato(payload: ContatoLead) {
    const dn = this.selectedDnService.getSelectedDn();
    if (!dn) {
      throw new Error('DN não selecionado');
    }
    // Converte a data para string ISO local (sem conversão UTC)
    const payloadToSend = {
      ...payload,
      dataRetorno: DateUtil.convertDateToLocalISOString(payload.dataRetorno)
    };
    return this.post(`/lead/${dn}/contato`, payloadToSend);
  }
}
